import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { ThemeMode, useTheme } from "@teamworksdev/mui";

export const ThemePreference = () => {
  const { themeMode, setThemeMode, setAllowToggleThemeMode } = useTheme();
  setAllowToggleThemeMode(true);

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h2">Theme Preference</Typography>
      <ToggleButtonGroup
        value={themeMode}
        exclusive
        onChange={(_event, value) => {
          if (value !== null) {
            writeThemePreferenceToLocalStorage(value);
            setThemeMode(value);
          }
        }}
      >
        <ToggleButton value="light">
          <LightModeOutlinedIcon /> Light
        </ToggleButton>
        <ToggleButton value="system">
          <SettingsBrightnessIcon /> System
        </ToggleButton>
        <ToggleButton value="dark">
          <DarkModeOutlinedIcon /> Dark
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

const THEME_PREFERENCE_KEY = "teamworks.performance.theme-preference";
export const readThemePreferenceFromLocalStorage = () => (localStorage.getItem(THEME_PREFERENCE_KEY) || "light") as ThemeMode;
export const writeThemePreferenceToLocalStorage = (themePreference: ThemeMode) =>
  localStorage.setItem(THEME_PREFERENCE_KEY, themePreference);
